import parseStoryBoardUrl from '../../../../a-react-app/src/libs/parseStoryBoardUrl/parseStoryBoardUrl.js';

export class AuthTypes {
	static getEmailHash() {
		const emailHash = window.location.href.match(/\/bar\/([^?#]*)/);
		return emailHash ? emailHash[1] : undefined;
	}

	static getBoardHash() {
		const board = parseStoryBoardUrl(window.location.href);
		return board ? board.hash : undefined;
	}

	static getSecretPostHash() {
		const secretPostHash = window.location.href.match(/\/link\/([^#]*)/);
		return secretPostHash ? secretPostHash[1] : undefined;
	}

	static getJwt(storage) {
		const jwt = storage.getItem('jwt');
		if (jwt && jwt.token && jwt.payload && jwt.payload.exp > +new Date() / 1000) {
			return jwt.token;
		}
		return undefined;
	}

	static isPublic(url) {
		return /(\/auth\/type|\/auth\/login|\/auth\/is_remembered)$/.test(url);
	}

	static getHeader(url, storage) {
		let auth;
		if (AuthTypes.isPublic(url)) {
			return 'Public';
		}
		if ((auth = AuthTypes.getEmailHash())) {
			return `Email ${auth}`;
		}
		if ((auth = AuthTypes.getBoardHash())) {
			return `Board ${auth}`;
		}
		//TODO: consider moving this below bearer auth for phase 2 if we want logged in users to have a different experience
		// there will almost certainly be other changes besides just this though.
		if ((auth = AuthTypes.getSecretPostHash())) {
			return `SecretPost ${auth}`;
		}
		if ((auth = AuthTypes.getJwt(storage))) {
			return `Bearer ${auth}`;
		}
		return undefined;
	}

	static getUrlParam(url, storage) {
		const auth = AuthTypes.getHeader(url, storage);
		if (auth) {
			return 'addHeaders=' + encodeURIComponent(JSON.stringify({ Authorization: auth }));
		}
		return '';
	}
}
